import { render } from "./billCodeInfo.vue?vue&type=template&id=380846b4&scoped=true"
import script from "./billCodeInfo.vue?vue&type=script&lang=js"
export * from "./billCodeInfo.vue?vue&type=script&lang=js"

import "./billCodeInfo.vue?vue&type=style&index=0&id=380846b4&lang=less&scoped=true"

import exportComponent from "D:\\project\\Mase_Customer\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380846b4"]])

export default __exports__